var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerForSignUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 848.99 888",
    style: {
      enableBackground: "new 0 0 848.99 888"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shadow"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  })), /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89CAF7"
    },
    d: "M438.52,700.12c-14.53-0.01-29.06-0.02-43.59-0.02"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.56,
      fill: "#D2EBFF"
    },
    cx: 505.31,
    cy: 729.82,
    rx: 322.55,
    ry: 55.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67B8EF"
    },
    d: "M762.76,515.39c0-41.43-29.26-82.95-65.36-82.95c-36.1,0-65.36,41.52-65.36,82.95 c0,41.43,29.26,75.02,65.36,75.02C733.5,590.41,762.76,556.83,762.76,515.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#34648C"
    },
    d: "M697.4,432.44c-5.81,0-11.41,1.18-16.78,3.15c27.95,10.31,48.58,45.04,48.58,79.8 c0,34.76-20.63,63.92-48.58,72.43c5.36,1.63,10.96,2.59,16.78,2.59c36.1,0,65.36-33.59,65.36-75.02 C762.76,473.96,733.5,432.44,697.4,432.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67B8EF"
    },
    d: "M381.01,515.39c0-41.43-29.26-82.95-65.36-82.95c-36.1,0-65.36,41.52-65.36,82.95 c0,41.43,29.26,75.02,65.36,75.02C351.75,590.41,381.01,556.83,381.01,515.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#34648C"
    },
    d: "M315.65,432.44c-5.81,0-11.41,1.18-16.78,3.15c27.95,10.31,48.58,45.04,48.58,79.8 c0,34.76-20.63,63.92-48.58,72.43c5.36,1.63,10.96,2.59,16.78,2.59c36.1,0,65.36-33.59,65.36-75.02 C381.01,473.96,351.75,432.44,315.65,432.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M256.87,586.85l14.23,88.07c2.02,12.49,12.8,21.67,25.45,21.67h43.36 c12.65,0,23.43-9.18,25.45-21.67l14.23-88.07H256.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACCFE5"
    },
    d: "M379.59,586.85h-24.17h-98.55l1.97,12.2h94.61l-12.26,75.87c-2.02,12.49-12.8,21.67-25.45,21.67 h24.17c12.65,0,23.43-9.18,25.45-21.67l12.26-75.87l0,0L379.59,586.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M380.96,561.51H255.5c-7.05,0-12.82,5.77-12.82,12.82l0,0c0,7.05,5.77,12.82,12.82,12.82h125.46 c7.05,0,12.82-5.77,12.82-12.82l0,0C393.78,567.28,388.01,561.51,380.96,561.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M633.18,586.85l14.23,88.07c2.02,12.49,12.8,21.67,25.45,21.67h43.36 c12.65,0,23.43-9.18,25.45-21.67l14.23-88.07H633.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACCFE5"
    },
    d: "M755.9,586.85h-24.17h-98.55l1.97,12.2h94.61l-12.26,75.87c-2.02,12.49-12.8,21.67-25.45,21.67 h24.17c12.65,0,23.43-9.18,25.45-21.67l12.26-75.87l0,0L755.9,586.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M757.27,561.51H631.81c-7.05,0-12.82,5.77-12.82,12.82l0,0c0,7.05,5.77,12.82,12.82,12.82h125.46 c7.05,0,12.82-5.77,12.82-12.82l0,0C770.09,567.28,764.32,561.51,757.27,561.51z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M658.98,413.17h79.02c10.33,0,18.92-8.18,19.17-18.51c0.01-0.24,0.01-0.48,0.01-0.72 c0.01-15.95-12.8-29.12-28.75-29.54c-2.77-0.07-5.45,0.24-8,0.88c-2.5-11.29-12.57-19.74-24.61-19.74 c-12.56,0-22.97,9.19-24.89,21.21c-2.45-0.67-5.04-0.98-7.73-0.87c-13.69,0.56-24.32,11.81-24.15,25.51 c0.06,4.54,1.31,8.79,3.46,12.44C645.93,409.65,652.22,413.17,658.98,413.17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89CAF7"
    },
    d: "M630.54,130.94l-283.01-0.59c-22-0.05-40.04,17.92-40.09,39.92l-0.94,482.6 c-0.05,22,17.92,40.04,39.92,40.09l283.01,0.59c22,0.05,40.04-17.92,40.09-39.92l0.94-482.6 C670.51,149.03,652.54,130.99,630.54,130.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M627.99,164.01l-31.05-0.06c-2.62-0.01-5.07,1.31-6.52,3.49l-7.33,11.05 c-7.59,11.45-20.42,18.32-34.16,18.29l-120.08-0.25c-13.74-0.03-26.54-6.95-34.08-18.43l-7.28-11.08 c-1.44-2.19-3.88-3.51-6.51-3.52l-31.05-0.06c-4.31-0.01-7.81,3.48-7.82,7.79l-0.94,480.85c-0.01,4.31,3.48,7.81,7.79,7.82 l278.05,0.58c4.31,0.01,7.81-3.48,7.82-7.79l0.94-480.85C635.79,167.52,632.3,164.02,627.99,164.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M603.7,565.78l-240.03-0.5c-1.46,0-2.66,1.19-2.66,2.65l-0.3,143.62c0,1.46,1.19,2.66,2.65,2.66 l240.03,0.5c1.46,0,2.66-1.19,2.66-2.65l0.3-143.62C606.35,566.98,605.16,565.78,603.7,565.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M577.97,694.23l-184.75-0.1c-1.42,0-2.57,1.15-2.58,2.57l-0.06,0.23c0,1.42,1.15,2.57,2.57,2.58 l184.75,0.1c1.41,0,2.58-1.15,2.58-2.57l0.06-0.23C580.54,695.39,579.38,694.23,577.97,694.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89CAF7"
    },
    d: "M577.97,694.23l-130.76-0.07v5.37l130.69,0.07c1.42,0,2.58-1.15,2.58-2.57l0.06-0.23 C580.54,695.39,579.38,694.23,577.97,694.23z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M762.96,200.73l-224.71-0.47c-1.37,0-2.49,1.11-2.49,2.48l-0.28,134.45 c0,1.37,1.11,2.49,2.48,2.49l224.71,0.47c1.37,0,2.49-1.11,2.49-2.48l0.28-134.45C765.44,201.85,764.33,200.73,762.96,200.73z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M704.14,233.76H596.78c-4,0-7.28,3.28-7.28,7.28l0,0c0,4,3.28,7.28,7.28,7.28h107.35 c4,0,7.28-3.28,7.28-7.28l0,0C711.41,237.04,708.14,233.76,704.14,233.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M678.66,267.43h-56.41c-4,0-7.28,3.28-7.28,7.28l0,0c0,4,3.28,7.28,7.28,7.28h56.41 c4,0,7.28-3.27,7.28-7.28l0,0C685.94,270.7,682.66,267.43,678.66,267.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M696.25,300.62h-91.58c-4,0-7.28,3.28-7.28,7.28l0,0c0,4,3.28,7.28,7.28,7.28h91.58 c4,0,7.28-3.28,7.28-7.28l0,0C703.53,303.9,700.25,300.62,696.25,300.62z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67B8EF"
    },
    d: "M238.11,280.67h101.67c13.29,0,24.35-10.52,24.67-23.81c0.01-0.31,0.01-0.61,0.01-0.92 c0.01-20.52-16.47-37.47-36.99-38.01c-3.56-0.09-7.01,0.31-10.3,1.13c-3.22-14.53-16.17-25.4-31.67-25.4 c-16.16,0-29.56,11.82-32.03,27.29c-3.15-0.86-6.49-1.26-9.94-1.12c-17.61,0.72-31.3,15.2-31.08,32.82 c0.07,5.84,1.69,11.3,4.45,16.01C221.32,276.14,229.42,280.67,238.11,280.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M516.78,108.31h79.02c10.33,0,18.92-8.18,19.17-18.51c0.01-0.24,0.01-0.48,0.01-0.72 c0.01-15.95-12.8-29.12-28.75-29.54c-2.77-0.07-5.45,0.24-8,0.88c-2.5-11.29-12.57-19.74-24.61-19.74 c-12.56,0-22.97,9.19-24.89,21.21c-2.45-0.67-5.04-0.98-7.73-0.87c-13.69,0.56-24.32,11.81-24.15,25.51 c0.06,4.54,1.31,8.79,3.46,12.44C503.73,104.79,510.03,108.31,516.78,108.31z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA45"
    },
    d: "M468.73,195.82l-270.68-0.56c-1.65,0-3,1.34-3,2.99l-0.34,161.97c0,1.65,1.34,3,2.99,3 l270.68,0.56c1.65,0,3-1.34,3-2.99l0.34-161.97C471.72,197.17,470.38,195.82,468.73,195.82z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M444.67,250.68h-113.8c-2.66,0-4.84,2.18-4.84,4.84l0,0c0,2.66,2.18,4.84,4.84,4.84h113.8 c2.66,0,4.84-2.18,4.84-4.84l0,0C449.51,252.86,447.33,250.68,444.67,250.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M419.04,274.54h-88.17c-2.66,0-4.84,2.18-4.84,4.84l0,0c0,2.66,2.18,4.84,4.84,4.84h88.17 c2.66,0,4.84-2.18,4.84-4.84l0,0C423.88,276.72,421.7,274.54,419.04,274.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M410.66,297.27h-83.51c-0.62,0-1.12,0.51-1.12,1.12v7.43c0,0.62,0.5,1.12,1.12,1.12h83.51 c0.62,0,1.12-0.51,1.12-1.12v-7.43C411.79,297.77,411.28,297.27,410.66,297.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.83,254.71c0,10.42-8.17,18.87-18.24,18.87c-10.08,0-18.24-8.45-18.24-18.87 c0-10.42,8.17-18.87,18.24-18.87C270.66,235.85,278.83,244.29,278.83,254.71z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.81,287.17l-11-3.58c-7.92-2.58-16.46-2.58-24.38-0.01l-11.08,3.59 c-6.82,2.21-11.44,8.56-11.44,15.73v17.79h27.56h14.22h27.56V302.9C295.25,295.74,290.63,289.38,283.81,287.17z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1677D8"
    },
    d: "M109.43,409.73c0,0-29.71,6.37-45.88,70.07c-5.69,22.41,35.92,74.16,35.92,74.16L109.43,409.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M154.77,782.84c-0.82,5.11-6.25,16.74,1.84,18.57c0,0,59.49,14.24,59.49,14.24 c5.08,1.22,9.6-4.46,7.63-9.67c-7.35-11.59-42.33-29.94-60.54-32.59L154.77,782.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB5B1"
    },
    d: "M249.93,329.34c0,0,4.27-27.92,11.08-26.64c4.51,1.01,3.35,8.31,3.9,11.58 c3.05-2.42,10.23-24.72,16.43-16.62c15.03,11.48-6.55,34.68-14.7,40.75C262.49,338.71,253.13,331.56,249.93,329.34z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#053272"
    },
    points: "145.16,549.66 208.38,645.91 192.03,784.63 155.54,782.11 167.81,669.5 111.1,596.64  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M158.13,341.15c-5.69-60.99-94.18-8.71-48.95,48.19l26.49-8.36L158.13,341.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M21.21,797.62c0.39,5.16-2.18,17.74,6.11,17.63c0,0,61.18,0,61.18,0c5.23,0,8.29-6.57,5.17-11.18 c-9.84-9.56-48.14-19.27-66.46-17.6L21.21,797.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M84.81,558.96h67.02l-95.5,229.8l-34.93,9.37C32.76,757.36,87.64,601.93,84.81,558.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M148.88,407.63c0,0,27.55,100.65,21.43,152.47c-29.78,10.78-62.46,11.58-92.46,1.21l0,0 c3.29-9.89-10.69-148.09,39.06-153.93L148.88,407.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB5B1"
    },
    d: "M108.93,387.74l5.59,27.32l27.24-5.57l-2-9.78c31.72,4.12,23.81-37.08,18.34-58.77 c0,0-7.97,8.36-24.88,13.55l-3.35,14.32L108.93,387.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB5B1"
    },
    d: "M116.12,375.26c-2.25-10.3,13.03-13.42,15-3.07C133.37,382.49,118.09,385.62,116.12,375.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M114.34,408.39c107.2-9.88,72.85,4.09,135.05-81.18l21.74,8.72 c-7.12,7.45-52.05,98.85-64.67,96.42c0,0-84.92,15.44-84.92,15.44c-12.44,2.18-23.77-7.56-23.47-20.19l0,0 C98.29,418.16,105.07,410.15,114.34,408.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB5B1"
    },
    d: "M159.34,351.83c0,0,9.97,14.1,9.76,15.24c-0.21,1.15-7.89,5.04-7.89,5.04L159.34,351.83z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M704.77,667.57c1.95-117.28-50.44-165.4-50.44-165.4c-12.78,64.7,7.64,133.99,19.01,165.4 H704.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M733.34,667.57c57.12-77.85,47.9-138.92,47.9-138.92c-49.34,41.13-74.85,109.44-83.73,137.64 l1.46,1.28H733.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M767.73,667.57c48.7-49.28,58.73-89.07,58.73-89.07c-60.17,24.27-89.7,63.64-104.98,89.07 H767.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M681.05,667.57c-18.64-84.32-64.12-109.77-64.12-109.77c0.98,43.64,20.9,85.32,35.18,109.77 H681.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M731.5,667.57c24.71-137.34-14.77-190.25-14.77-190.25c-47.1,47.78-29.25,160.76-23.61,190.25 H731.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M720.62,666.7c-4.67-50.62-4.14-104.11-8.2-153.47c-2.2,49.34,3.52,102.88,6.04,153.47H720.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M688.34,666.7h2.26c-12.94-36.89-20.54-104.58-31.69-141.32 C663.94,563.43,677.57,629.27,688.34,666.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M665.89,666.7c-46.55-111.47-49.57-107.59-2.38,0H665.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M726.98,666.7c14.4-37.67,29.32-77.67,42.84-114.46c-19.63,34.93-28.45,77.42-45.28,114.46 H726.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M734.53,666.7c7.85-10.49,65.79-60.37,73.03-71.81c-12.85,8.4-65.4,61.13-75.89,71.81H734.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M652.2,687.78l14.23,88.07c3.3,30.6,48.85,19.91,68.81,21.67c12.65,0,23.43-9.18,25.45-21.67 l14.23-88.07H652.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACCFE5"
    },
    d: "M774.92,687.78c-15.43,0-105.28,0-122.72,0l1.97,12.2h94.61l-12.26,75.87 c-2.02,12.49-12.8,21.67-25.45,21.67c18.08,0.66,46.63,2.56,49.62-21.67c0,0,12.26-75.86,12.26-75.86l0,0L774.92,687.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M776.29,662.45H650.83c-7.05,0-12.82,5.77-12.82,12.82l0,0c0,7.05,5.77,12.82,12.82,12.82h125.46 c7.05,0,12.82-5.77,12.82-12.82l0,0C789.11,668.22,783.34,662.45,776.29,662.45z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "shield"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "lady"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerForSignUp);
export default __webpack_public_path__ + "static/media/BannerForSignUp.b2c30d69b4987f22f3e6bd7dace12b5c.svg";
export { ForwardRef as ReactComponent };